import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { Baseurl } from "../config/BaseUrl";
import {
  currAdress,
  updateAddress,
} from "../redux/authentication/AuthenticationSlice";
import {
  FaMapMarkerAlt,
  FaEdit,
  FaHome,
  FaPlus,
  FaCrosshairs,
  FaCheck,
} from "react-icons/fa";

const AddressComponent = () => {
  const { address, loginData, currentAddress } = useSelector(
    (state) => state.Authentication
  );
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [addressForm, setAddressForm] = useState({
    HNo: "",
    AName: "",
    StreetDet: "",
    AreaDet: "",
    LandMark: "",
    City: "",
    State: "Telangana",
    Pincode: "",
    Mobile: "",
    Type: "Home",
  });
  const [formErrors, setFormErrors] = useState({});
  const [addLoading, setAddLoading] = useState(false);
  const [locationLoading, setLocationLoading] = useState(false);
  const dispatch = useDispatch();

  // Get current location
  const getCurrentLocation = () => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error("Geolocation is not supported"));
        return;
      }
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });
  };

  // Auto-fill address from current location
  const autoFillFromLocation = async () => {
    setLocationLoading(true);
    try {
      const position = await getCurrentLocation();
      const { latitude, longitude } = position.coords;

      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&addressdetails=1`
      );
      const data = await response.json();

      if (data && data.address) {
        const addr = data.address;
        setAddressForm((prev) => ({
          ...prev,
          HNo: addr.house_number || addr.house || "",
          StreetDet: addr.road || "",
          AreaDet: addr.suburb || addr.neighbourhood || "",
          City: addr.city || addr.town || addr.village || "",
          State: addr.state || "Telangana",
          Pincode: addr.postcode || "",
          AName: addr.suburb || addr.city || "",
        }));
      }
    } catch (error) {
      alert("Unable to get your location. Please enter address manually.");
    } finally {
      setLocationLoading(false);
    }
  };

  // Validation function
  const validateForm = () => {
    const errors = {};
    if (!addressForm.HNo) errors.HNo = "House number is required";
    if (!addressForm.AName) errors.AName = "Area name is required";
    if (!addressForm.AreaDet) errors.AreaDet = "Area details are required";
    if (!addressForm.City) errors.City = "City is required";
    if (!addressForm.Pincode || addressForm.Pincode.length !== 6)
      errors.Pincode = "Valid 6-digit pincode is required";
    if (!addressForm.Mobile || addressForm.Mobile.length !== 10)
      errors.Mobile = "Valid 10-digit mobile number is required";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleAddAddress = async () => {
    if (!validateForm()) return;
    setAddLoading(true);

    try {
      const formData = {
        AName: addressForm.AName,
        Number: addressForm.Mobile,
        Pincode: parseInt(addressForm.Pincode),
        State: addressForm.State,
        City: addressForm.City,
        HNo: addressForm.HNo,
        StreetDet: addressForm.StreetDet,
        LandMark: addressForm.LandMark,
        AreaDet: addressForm.AreaDet,
        Type: addressForm.Type,
        Tag: "",
        prime: false,
        Mobile: addressForm.Mobile,
        ClientId: loginData._id,
      };

      const response = await axios.put(
        `${Baseurl}/api/v1/client/address`,
        formData
      );

      if (response.data.success) {
        const updatedAddresses = response.data.client?.Addresses || [
          ...address,
          response.data.data,
        ];
        dispatch(updateAddress(updatedAddresses));

        if (address.length === 0) {
          const newAddress =
            response.data.data || response.data.client?.Addresses?.[0];
          if (newAddress) dispatch(currAdress(newAddress));
        }

        setShowAddModal(false);
        resetForm();
        alert("Address added successfully!");
      }
    } catch (error) {
      alert("Failed to add address. Please try again.");
    }
    setAddLoading(false);
  };

  const handleEditAddress = (address) => {
    setSelectedAddress(address);
    setAddressForm({
      HNo: address.HNo || "",
      AName: address.AName || "",
      StreetDet: address.StreetDet || "",
      AreaDet: address.AreaDet || "",
      LandMark: address.LandMark || "",
      City: address.City || "",
      State: address.State || "Telangana",
      Pincode: address.Pincode || "",
      Mobile: address.Mobile || "",
      Type: address.Type || "Home",
    });
    setShowEditModal(true);
  };

  const handleSaveAddress = async () => {
    if (!validateForm()) return;

    try {
      const formData = {
        addressId: selectedAddress._id,
        AName: addressForm.AName,
        Number: addressForm.Mobile,
        Pincode: parseInt(addressForm.Pincode),
        State: addressForm.State,
        City: addressForm.City,
        HNo: addressForm.HNo,
        StreetDet: addressForm.StreetDet,
        LandMark: addressForm.LandMark,
        AreaDet: addressForm.AreaDet,
        Type: addressForm.Type,
        Tag: "",
        prime: selectedAddress.prime || false,
        Mobile: addressForm.Mobile,
        ClientId: loginData._id,
      };

      const response = await axios.put(
        `${Baseurl}/api/v1/client/updateclientsingleaddress`,
        formData
      );

      if (response.data.success) {
        const updatedAddresses = response.data.client.Addresses;
        dispatch(updateAddress(updatedAddresses));

        if (selectedAddress._id === currentAddress._id) {
          const updatedAddress = updatedAddresses.find(
            (addr) => addr._id === selectedAddress._id
          );
          if (updatedAddress) dispatch(currAdress(updatedAddress));
        }

        setShowEditModal(false);
        resetForm();
        alert("Address updated successfully!");
      }
    } catch (error) {
      alert("Failed to update address");
    }
  };

  const handleSelectAddress = (address) => {
    dispatch(currAdress(address));
    setShowAddressModal(false);
  };

  const resetForm = () => {
    setAddressForm({
      HNo: "",
      AName: "",
      StreetDet: "",
      AreaDet: "",
      LandMark: "",
      City: "",
      State: "Telangana",
      Pincode: "",
      Mobile: "",
      Type: "Home",
    });
    setFormErrors({});
  };

  return (
    <>
      {/* Modern Address Section */}
      <div className="mb-4 text-start">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div className="text-start">
            <div className="fw-bold text-dark " style={{ fontSize: "16px" }}>
              Delivery Address
            </div>
            <div className="text-muted" style={{ fontSize: "13px" }}>
              Where should we deliver your order?
            </div>
          </div>
          <button
            className="btn btn-outline-primary btn-sm rounded-pill px-3 fw-semibold"
            onClick={() => setShowAddressModal(true)}
            style={{ fontSize: "12px" }}
          >
            Change
          </button>
        </div>

        {currentAddress ? (
          <div
            className="rounded-4 px-2 py-2 border-0 "
            style={{ backgroundColor: "#f5f6fb" }}
          >
            <div className="d-flex justify-content-between text-start align-items-start">
              <div className="flex-grow-1 text-start">
                <div className="d-flex align-items-center text-start">
                  <div className="d-flex align-items-cente text-start">
                    <div style={{ fontSize: "14px" }} className="text-dark">
                      {loginData?.Name}
                    </div>
                    <div
                      className="ps-2 text-primary  fw-semibold"
                      style={{ fontSize: "12px" }}
                    >
                      {currentAddress.Type}
                    </div>
                  </div>
                </div>
                <div
                  className=" row d-flex flex-wrap"
                  style={{ fontSize: "14px" }}
                >
                  {/* Address Line 1 */}
                  <div className="text-dark mb-1">
                    {currentAddress.HNo}, {currentAddress.AName},{" "}
                    {currentAddress.City}, {currentAddress.State} -{" "}
                    {currentAddress.Pincode},{currentAddress.LandMark},
                    {currentAddress.Mobile}
                  </div>
                </div>
              </div>
              <button
                className="border-0"
                onClick={() => handleEditAddress(currentAddress)}
              >
                <FaEdit size={14} />
              </button>
            </div>
          </div>
        ) : (
          <div className="bg-warning bg-opacity-10 rounded-4 p-4 text-center border border-warning border-2 border-dashed">
            <FaMapMarkerAlt className="text-warning mb-3" size={40} />
            <h6 className="fw-bold text-warning mb-2">No Address Added</h6>
            <p className="text-warning mb-3">
              Please add a delivery address to continue with your order
            </p>
            <button
              className="btn btn-primary rounded-pill px-4 py-2 fw-semibold"
              onClick={() => setShowAddModal(true)}
            >
              <FaPlus className="me-2" />
              Add Delivery Address
            </button>
          </div>
        )}
      </div>

      {showAddressModal && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center text-start"
          style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: "1050" }}
          onClick={() => setShowAddressModal(false)}
        >
          <div
            className="bg-white rounded-4 shadow-lg p-4 text-start"
            style={{
              width: "550px", // Fixed width
              maxWidth: "90%", // Responsive fallback
              position: "relative",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              className="position-absolute top-0 end-0 m-3 btn-close"
              onClick={() => setShowAddressModal(false)}
            ></button>

            {/* Header Section */}
            <h5 className="fw-bold mb-1">Select Delivery Address</h5>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                Choose from your saved addresses
              </p>
              <button
                className=" rounded-pill px-4 fw-semibold border-0 py-2  text-white"
                onClick={() => setShowAddModal(true)}
                style={{ fontSize: "12px", backgroundColor: "#1469A7" }}
              >
                <FaPlus className="me-2" /> Add New
              </button>
            </div>

            {/* Address List */}
            <div className="text-start">
              {address.map((addr) => (
                <div
                  key={addr._id}
                  className={`p-3 rounded-3 shadow-sm mb-3 ${
                    currentAddress?._id === addr._id
                      ? "border border-primary bg-primary bg-opacity-10"
                      : "border border-light bg-white"
                  }`}
                  style={{ cursor: "pointer", transition: "0.3s" }}
                  onClick={() => handleSelectAddress(addr)}
                >
                  <div className="d-flex justify-content-between align-items-start">
                    <div className="d-flex align-items-center">
                      <div className=" me-3">
                        <FaMapMarkerAlt className="text-primary" size={15} />
                      </div>
                      <div className="d-flex gap-2 align-items-center">
                        <div
                          style={{ fontSize: "14px" }}
                          className="mb-0 fw-bold"
                        >
                          {loginData?.Name}
                        </div>
                        <div
                          style={{ fontSize: "12px" }}
                          className="text-muted"
                        >
                          {addr.Type}
                        </div>
                      </div>
                    </div>
                    {currentAddress?._id === addr._id && (
                      <span className="badge bg-success bg-opacity-10 text-success px-3 py-1 rounded-pill">
                        <FaCheck size={10} className="me-1" />
                        Selected
                      </span>
                    )}
                  </div>

                  <div className="mt-2 small text-dark">
                    {addr.HNo}, {addr.AName}, {addr.City}, {addr.State} -{" "}
                    {addr.LandMark},{addr.Pincode},{addr.Mobile}
                  </div>
                </div>
              ))}
            </div>

            {/* Empty State */}
            {address.length === 0 && (
              <div className="text-center py-5">
                <FaMapMarkerAlt
                  size={50}
                  className="text-muted opacity-50 mb-3"
                />
                <h6 className="fw-bold">No Addresses Found</h6>
                <p className="text-muted">Add your first address to continue</p>
                <button
                  className=" rounded-pill px-4 py-3 text-white"
                  onClick={() => setShowAddModal(true)}
                  style={{ backgroundColor: "#b93c5b" }}
                >
                  <FaPlus className="me-2" /> Add Address
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {showAddModal && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: "1050",
            animation: "fadeIn 0.2s ease-out",
          }}
          onClick={() => setShowAddModal(false)}
        >
          <div
            className="bg-white rounded-4 shadow-lg"
            style={{
              width: "90%",
              maxWidth: "650px",
              maxHeight: "90vh",
              overflow: "hidden",
              animation: "slideUp 0.3s ease-out",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header Section */}
            <div className="p-4 border-bottom">
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <h5 className="fw-bold text-dark mb-1 text-start">
                    Add New Address
                  </h5>
                  <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                    Enter your complete delivery address
                  </p>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowAddModal(false)}
                ></button>
              </div>
            </div>

            {/* Scrollable Content */}
            <div style={{ maxHeight: "calc(90vh - 200px)", overflowY: "auto" }}>
              <div className="p-4">
                {/* Auto Fill Button */}
                <div className="mb-4">
                  <button
                    type="button"
                    className="btn btn-outline-primary w-100 rounded-3 py-3 fw-semibold d-flex align-items-center justify-content-center"
                    onClick={autoFillFromLocation}
                    disabled={locationLoading}
                  >
                    {locationLoading ? (
                      <>
                        <div
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        ></div>
                        Detecting Location...
                      </>
                    ) : (
                      <>
                        <FaCrosshairs className="me-2" /> Use Current Location
                      </>
                    )}
                  </button>
                  <div className="text-start mt-2">
                    <small className="text-muted" style={{ fontSize: "14px" }}>
                      We'll automatically fill your address details from your
                      current location
                    </small>
                  </div>
                </div>

                {/* Form Fields */}
                <div className="row g-3 text-start">
                  {/* House/Flat No. */}
                  <div className="col-12 col-md-6 text-start">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      House/Flat No.*
                    </label>
                    <input
                      type="text"
                      className={`form-control rounded-3 py-2  ${
                        formErrors.HNo ? "is-invalid border-1" : "border"
                      }`}
                      value={addressForm.HNo}
                      onChange={(e) => {
                        setAddressForm((prev) => ({
                          ...prev,
                          HNo: e.target.value,
                        }));
                        if (formErrors.HNo)
                          setFormErrors((prev) => ({ ...prev, HNo: "" }));
                      }}
                      placeholder="Enter house/flat number"
                    />
                    {formErrors.HNo && (
                      <div className="invalid-feedback text-start">
                        {formErrors.HNo}
                      </div>
                    )}
                  </div>

                  {/* Area Name */}
                  <div className="col-12 col-md-6">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      Area Name*
                    </label>
                    <input
                      type="text"
                      className={`form-control rounded-3 py-2 ${
                        formErrors.AName ? "is-invalid border-2" : "border"
                      }`}
                      value={addressForm.AName}
                      onChange={(e) => {
                        setAddressForm((prev) => ({
                          ...prev,
                          AName: e.target.value,
                        }));
                        if (formErrors.AName)
                          setFormErrors((prev) => ({ ...prev, AName: "" }));
                      }}
                      placeholder="Enter area name"
                    />
                    {formErrors.AName && (
                      <div className="invalid-feedback text-start">
                        {formErrors.AName}
                      </div>
                    )}
                  </div>

                  {/* Street Details */}
                  <div className="col-12 ">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      Street Details
                    </label>
                    <input
                      type="text"
                      className="form-control rounded-3 py-2 border"
                      value={addressForm.StreetDet}
                      onChange={(e) =>
                        setAddressForm((prev) => ({
                          ...prev,
                          StreetDet: e.target.value,
                        }))
                      }
                      placeholder="Enter street details"
                    />
                  </div>

                  {/* Area Details */}
                  <div className="col-12">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      Area Details*
                    </label>
                    <input
                      type="text"
                      className={`form-control rounded-3 py-2 ${
                        formErrors.AreaDet ? "is-invalid border-2" : "border"
                      }`}
                      value={addressForm.AreaDet}
                      onChange={(e) => {
                        setAddressForm((prev) => ({
                          ...prev,
                          AreaDet: e.target.value,
                        }));
                        if (formErrors.AreaDet)
                          setFormErrors((prev) => ({ ...prev, AreaDet: "" }));
                      }}
                      placeholder="Enter area details"
                    />
                    {formErrors.AreaDet && (
                      <div className="invalid-feedback text-start">
                        {formErrors.AreaDet}
                      </div>
                    )}
                  </div>

                  {/* Landmark */}
                  <div className="col-12">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      Landmark
                    </label>
                    <input
                      type="text"
                      className="form-control rounded-3 py-2 border"
                      value={addressForm.LandMark}
                      onChange={(e) =>
                        setAddressForm((prev) => ({
                          ...prev,
                          LandMark: e.target.value,
                        }))
                      }
                      placeholder="Enter nearby landmark"
                    />
                  </div>

                  {/* City */}
                  <div className="col-12 col-md-6">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      City*
                    </label>
                    <input
                      type="text"
                      className={`form-control rounded-3 py-2 ${
                        formErrors.City ? "is-invalid border-2" : "border"
                      }`}
                      value={addressForm.City}
                      onChange={(e) => {
                        setAddressForm((prev) => ({
                          ...prev,
                          City: e.target.value,
                        }));
                        if (formErrors.City)
                          setFormErrors((prev) => ({ ...prev, City: "" }));
                      }}
                      placeholder="Enter city"
                    />
                    {formErrors.City && (
                      <div className="invalid-feedback text-start">
                        {formErrors.City}
                      </div>
                    )}
                  </div>

                  {/* State */}
                  <div className="col-12 col-md-6">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      State
                    </label>
                    <input
                      type="text"
                      className="form-control rounded-3 py-2 border"
                      value={addressForm.State}
                      onChange={(e) =>
                        setAddressForm((prev) => ({
                          ...prev,
                          State: e.target.value,
                        }))
                      }
                      placeholder="Enter state"
                    />
                  </div>

                  {/* Pincode */}
                  <div className="col-12 col-md-6">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      Pincode*
                    </label>
                    <input
                      type="text"
                      className={`form-control rounded-3 py-2 ${
                        formErrors.Pincode ? "is-invalid border-2" : "border"
                      }`}
                      value={addressForm.Pincode}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setAddressForm((prev) => ({
                          ...prev,
                          Pincode: value,
                        }));
                        if (formErrors.Pincode)
                          setFormErrors((prev) => ({ ...prev, Pincode: "" }));
                      }}
                      placeholder="6-digit pincode"
                      maxLength={6}
                    />
                    {formErrors.Pincode && (
                      <div className="invalid-feedback text-start">
                        {formErrors.Pincode}
                      </div>
                    )}
                  </div>

                  {/* Mobile Number */}
                  <div className="col-12 col-md-6">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      Mobile Number*
                    </label>
                    <input
                      type="text"
                      className={`form-control rounded-3 py-2 ${
                        formErrors.Mobile ? "is-invalid border-2" : "border"
                      }`}
                      value={addressForm.Mobile}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setAddressForm((prev) => ({
                          ...prev,
                          Mobile: value,
                        }));
                        if (formErrors.Mobile)
                          setFormErrors((prev) => ({ ...prev, Mobile: "" }));
                      }}
                      placeholder="10-digit mobile number"
                      maxLength={10}
                    />
                    {formErrors.Mobile && (
                      <div className="invalid-feedback text-start">
                        {formErrors.Mobile}
                      </div>
                    )}
                  </div>

                  {/* Address Type */}
                  <div className="col-12">
                    <label className="form-label fw-semibold text-dark mb-3">
                      Address Type
                    </label>
                    <div className="d-flex gap-2 flex-wrap">
                      {["Home", "Office", "Other"].map((type) => (
                        <button
                          key={type}
                          type="button"
                          className={`btn flex-fill rounded-3 py-2 fw-semibold ${
                            addressForm.Type === type
                              ? "text-white shadow-sm"
                              : "text-primary border-2"
                          }`}
                          style={{
                            backgroundColor:
                              addressForm.Type === type
                                ? "#1469A7"
                                : "transparent",
                            borderColor: "#1469A7",
                            color:
                              addressForm.Type === type ? "#fff" : "#1469A7",
                          }}
                          onClick={() =>
                            setAddressForm((prev) => ({ ...prev, Type: type }))
                          }
                        >
                          {type}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer Buttons */}
            <div className="p-4 border-top bg-light">
              <div className="d-flex gap-3 justify-content-end">
                <button
                  type="button"
                  className="btn btn-outline-secondary rounded-3 px-4 py-2 fw-semibold"
                  onClick={() => setShowAddModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="border-0 text-white  rounded-3 px-4 py-2 fw-semibold"
                  style={{ backgroundColor: "#b93c5b" }}
                  onClick={handleAddAddress}
                  disabled={addLoading}
                >
                  {addLoading ? (
                    <>
                      <div
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      ></div>
                      Adding Address...
                    </>
                  ) : (
                    "Add Address"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modern Edit Address Modal - Design 1 Theme */}
      {showEditModal && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: "1050",
            animation: "fadeIn 0.2s ease-out",
          }}
          onClick={() => setShowEditModal(false)}
        >
          <div
            className="bg-white rounded-4 shadow-lg"
            style={{
              width: "90%",
              maxWidth: "650px",
              maxHeight: "90vh",
              overflow: "hidden",
              animation: "slideUp 0.3s ease-out",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header Section */}
            <div className="p-4 border-bottom">
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <h5 className="fw-bold text-dark mb-1 text-start">
                    Edit Address
                  </h5>
                  <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                    Update your delivery address details
                  </p>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowEditModal(false)}
                ></button>
              </div>
            </div>

            {/* Scrollable Content */}
            <div style={{ maxHeight: "calc(90vh - 200px)", overflowY: "auto" }}>
              <div className="p-4">
                {/* Form Fields */}
                <div className="row g-3 text-start">
                  {/* House/Flat No. */}
                  <div className="col-12 col-md-6 text-start">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      House/Flat No.*
                    </label>
                    <input
                      type="text"
                      className={`form-control rounded-3 py-2  ${
                        formErrors.HNo ? "is-invalid border-1" : "border"
                      }`}
                      value={addressForm.HNo}
                      onChange={(e) => {
                        setAddressForm((prev) => ({
                          ...prev,
                          HNo: e.target.value,
                        }));
                        if (formErrors.HNo)
                          setFormErrors((prev) => ({ ...prev, HNo: "" }));
                      }}
                      placeholder="Enter house/flat number"
                    />
                    {formErrors.HNo && (
                      <div className="invalid-feedback text-start">
                        {formErrors.HNo}
                      </div>
                    )}
                  </div>

                  {/* Area Name */}
                  <div className="col-12 col-md-6">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      Area Name*
                    </label>
                    <input
                      type="text"
                      className={`form-control rounded-3 py-2 ${
                        formErrors.AName ? "is-invalid border-2" : "border"
                      }`}
                      value={addressForm.AName}
                      onChange={(e) => {
                        setAddressForm((prev) => ({
                          ...prev,
                          AName: e.target.value,
                        }));
                        if (formErrors.AName)
                          setFormErrors((prev) => ({ ...prev, AName: "" }));
                      }}
                      placeholder="Enter area name"
                    />
                    {formErrors.AName && (
                      <div className="invalid-feedback text-start">
                        {formErrors.AName}
                      </div>
                    )}
                  </div>

                  {/* Street Details */}
                  <div className="col-12 ">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      Street Details
                    </label>
                    <input
                      type="text"
                      className="form-control rounded-3 py-2 border"
                      value={addressForm.StreetDet}
                      onChange={(e) =>
                        setAddressForm((prev) => ({
                          ...prev,
                          StreetDet: e.target.value,
                        }))
                      }
                      placeholder="Enter street details"
                    />
                  </div>

                  {/* Area Details */}
                  <div className="col-12">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      Area Details*
                    </label>
                    <input
                      type="text"
                      className={`form-control rounded-3 py-2 ${
                        formErrors.AreaDet ? "is-invalid border-2" : "border"
                      }`}
                      value={addressForm.AreaDet}
                      onChange={(e) => {
                        setAddressForm((prev) => ({
                          ...prev,
                          AreaDet: e.target.value,
                        }));
                        if (formErrors.AreaDet)
                          setFormErrors((prev) => ({ ...prev, AreaDet: "" }));
                      }}
                      placeholder="Enter area details"
                    />
                    {formErrors.AreaDet && (
                      <div className="invalid-feedback text-start">
                        {formErrors.AreaDet}
                      </div>
                    )}
                  </div>

                  {/* Landmark */}
                  <div className="col-12">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      Landmark
                    </label>
                    <input
                      type="text"
                      className="form-control rounded-3 py-2 border"
                      value={addressForm.LandMark}
                      onChange={(e) =>
                        setAddressForm((prev) => ({
                          ...prev,
                          LandMark: e.target.value,
                        }))
                      }
                      placeholder="Enter nearby landmark"
                    />
                  </div>

                  {/* City */}
                  <div className="col-12 col-md-6">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      City*
                    </label>
                    <input
                      type="text"
                      className={`form-control rounded-3 py-2 ${
                        formErrors.City ? "is-invalid border-2" : "border"
                      }`}
                      value={addressForm.City}
                      onChange={(e) => {
                        setAddressForm((prev) => ({
                          ...prev,
                          City: e.target.value,
                        }));
                        if (formErrors.City)
                          setFormErrors((prev) => ({ ...prev, City: "" }));
                      }}
                      placeholder="Enter city"
                    />
                    {formErrors.City && (
                      <div className="invalid-feedback text-start">
                        {formErrors.City}
                      </div>
                    )}
                  </div>

                  {/* State */}
                  <div className="col-12 col-md-6">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      State
                    </label>
                    <input
                      type="text"
                      className="form-control rounded-3 py-2 border"
                      value={addressForm.State}
                      onChange={(e) =>
                        setAddressForm((prev) => ({
                          ...prev,
                          State: e.target.value,
                        }))
                      }
                      placeholder="Enter state"
                    />
                  </div>

                  {/* Pincode */}
                  <div className="col-12 col-md-6">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      Pincode*
                    </label>
                    <input
                      type="text"
                      className={`form-control rounded-3 py-2 ${
                        formErrors.Pincode ? "is-invalid border-2" : "border"
                      }`}
                      value={addressForm.Pincode}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setAddressForm((prev) => ({
                          ...prev,
                          Pincode: value,
                        }));
                        if (formErrors.Pincode)
                          setFormErrors((prev) => ({ ...prev, Pincode: "" }));
                      }}
                      placeholder="6-digit pincode"
                      maxLength={6}
                    />
                    {formErrors.Pincode && (
                      <div className="invalid-feedback text-start">
                        {formErrors.Pincode}
                      </div>
                    )}
                  </div>

                  {/* Mobile Number */}
                  <div className="col-12 col-md-6">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      Mobile Number*
                    </label>
                    <input
                      type="text"
                      className={`form-control rounded-3 py-2 ${
                        formErrors.Mobile ? "is-invalid border-2" : "border"
                      }`}
                      value={addressForm.Mobile}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setAddressForm((prev) => ({
                          ...prev,
                          Mobile: value,
                        }));
                        if (formErrors.Mobile)
                          setFormErrors((prev) => ({ ...prev, Mobile: "" }));
                      }}
                      placeholder="10-digit mobile number"
                      maxLength={10}
                    />
                    {formErrors.Mobile && (
                      <div className="invalid-feedback text-start">
                        {formErrors.Mobile}
                      </div>
                    )}
                  </div>

                  {/* Address Type */}
                  <div className="col-12">
                    <label className="form-label fw-semibold text-dark mb-3">
                      Address Type
                    </label>
                    <div className="d-flex gap-2 flex-wrap">
                      {["Home", "Office", "Other"].map((type) => (
                        <button
                          key={type}
                          type="button"
                          className={`btn flex-fill rounded-3 py-2 fw-semibold ${
                            addressForm.Type === type
                              ? "text-white shadow-sm"
                              : "text-primary border-2"
                          }`}
                          style={{
                            backgroundColor:
                              addressForm.Type === type
                                ? "#1469A7"
                                : "transparent",
                            borderColor: "#1469A7",
                            color:
                              addressForm.Type === type ? "#fff" : "#1469A7",
                          }}
                          onClick={() =>
                            setAddressForm((prev) => ({ ...prev, Type: type }))
                          }
                        >
                          {type}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer Buttons */}
            <div className="p-4 border-top bg-light">
              <div className="d-flex gap-3 justify-content-end">
                <button
                  type="button"
                  className="btn btn-outline-secondary rounded-3 px-4 py-2 fw-semibold"
                  onClick={() => setShowEditModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="border-0 text-white rounded-3 px-4 py-2 fw-semibold"
                  style={{ backgroundColor: "#b93c5b" }}
                  onClick={handleSaveAddress}
                  disabled={addLoading}
                >
                  {addLoading ? (
                    <>
                      <div
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      ></div>
                      Updating Address...
                    </>
                  ) : (
                    "Update Address"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddressComponent;
